var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2705 13.0093C11.7831 13.0093 13.0093 11.7831 13.0093 10.2705C13.0093 8.75794 11.7831 7.53174 10.2705 7.53174C8.75794 7.53174 7.53174 8.75794 7.53174 10.2705C7.53174 11.7831 8.75794 13.0093 10.2705 13.0093Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70304 1.71167L6.13679 3.42342H3.42366C2.4822 3.42342 1.71191 4.19371 1.71191 5.13517V15.4057C1.71191 16.3471 2.4822 17.1174 3.42366 17.1174H17.1177C18.0591 17.1174 18.8294 16.3471 18.8294 15.4057V5.13517C18.8294 4.19371 18.0591 3.42342 17.1177 3.42342H14.4045L12.8383 1.71167H7.70304ZM10.2707 14.5498C7.90845 14.5498 5.99129 12.6326 5.99129 10.2704C5.99129 7.9082 7.90845 5.99104 10.2707 5.99104C12.6329 5.99104 14.55 7.9082 14.55 10.2704C14.55 12.6326 12.6329 14.5498 10.2707 14.5498Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.adc301c81bf060c71ab059be8bd12c6a.svg";
export { ForwardRef as ReactComponent };